import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {Illustration} from 'shells/illustrations/illustration';
import {ImageWrapper} from 'shells/onboarding-modal/image-wrapper';
import {OnboardingModal} from 'shells/onboarding-modal/onboarding-modal';

import {OpenableModals, useOpenableModal} from '../../../openable-modals';

import {appHistory} from '../../../../history';

import {ChooseEngagementActions} from './pages/choose-engagement-actions';
import {EnableEngagementBar} from './pages/enable-engagement-bar';
import {EnableSmartNudges} from './pages/enable-smart-nudges';
import {EngagementBarThreeStepSetup} from './pages/engagement-bar-three-step-setup';
import {UseEngagementActions} from './pages/use-engagement-actions';

export function EngagementBarOnboardingModal() {
    const {isOpen, onClose} = useOpenableModal(OpenableModals.ENGAGEMENT_BAR_ONBOARDING_MODAL);

    const pages = [
        {
            id: 'enable-engagement-bar',
            body: <EnableEngagementBar />,
            art: {
                background: colors.blueXlt,
                image: () => (
                    <Illustration
                        src='engagement-bar-onboarding/enable-engagement-actions'
                        width={330}
                    />
                ),
            },
        },
        {
            id: 'choose-engagement-actions',
            body: <ChooseEngagementActions />,
            art: {
                background: colors.blueXlt,
                image: () => (
                    <ImageWrapper
                        image={
                            <Illustration
                                src='engagement-bar-onboarding/choose-engagement-actions'
                                width={330}
                            />
                        }
                        width={330}
                    />
                ),
            },
        },
        {
            id: 'use-engagement-actions',
            body: <UseEngagementActions />,
            art: {
                background: colors.blueXlt,
                image: () => (
                    <ImageWrapper
                        image={
                            <Illustration
                                src='engagement-bar-onboarding/use-engagement-actions'
                                width={330}
                            />
                        }
                        width={330}
                    />
                ),
            },
        },
        {
            id: 'enable-smart-nudges',
            body: <EnableSmartNudges />,
            art: {
                background: colors.blueXlt,
                image: () => (
                    <ImageWrapper
                        image={
                            <Illustration
                                src='engagement-bar-onboarding/enable-smart-nudges'
                                width={330}
                            />
                        }
                        width={330}
                    />
                ),
            },
        },
        {
            id: '3-step-setup',
            body: <EngagementBarThreeStepSetup />,
            art: {
                background: colors.blueXlt,
                image: () => (
                    <ImageWrapper
                        image={
                            <Illustration
                                src='engagement-bar-onboarding/engagement-bar-setup'
                                width={330}
                            />
                        }
                        width={330}
                    />
                ),
            },
            nextButtonText: 'Go to setup',
            onClickNextButton: () => {
                appHistory.push('/inbox/settings/chat');
                onClose();
            },
        },
    ];

    return (
        isOpen && (
            <OnboardingModal
                trapFocus={false}
                lastButtonText='Done'
                pages={pages}
                onClose={onClose}
                onFinish={onClose}
                canClickOutsideToClose={false}
            />
        )
    );
}
